/* eslint-disable no-inner-declarations */
<template>
  <div id="app" v-preventright>
    <keep-alive include="login">
      <router-view />
    </keep-alive>
    <el-dialog
      title="应用更新......"
      :visible="showUpdater"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="620px"
      top="26vh"
      center
    >
      <template v-if="downloadProcess">
        <p>
          {{
            "当前:" +
              downloadProcess.transferred +
              "   /   共" +
              downloadProcess.total
          }}
        </p>
        <el-progress
          :text-inside="true"
          :stroke-width="18"
          :percentage="downloadProcess.percent"
        ></el-progress>
        <p>正在下载({{ downloadProcess.speed }})......</p>
      </template>
    </el-dialog>
    <el-dialog
      title="个人消息"
      :visible.sync="dialogVisible"
      width="500px"
      center
      :before-close="handleClose"
    >
      <p v-if="formData.type == 1" class="tipHeight">
        根据测试订单交易风险控制管理细则，
        您账户的资金风险率高于100%，在电话通知和短信提醒后，未能自行减少订货量或尽快补足可用资金，现于{{
          formData.tradeDay
        }}将您{{ formData.commodityInfo
        }}{{ formData.bsFlag == 1 ? '买' : '卖' }}方向的{{
          formData.quantity
        }}手持仓以{{ formData.price }}在{{
          formData.transferTime | dateFormate
        }}进行代为转让操作，请悉知。
      </p>
      <p v-else class="tipHeight">
        {{ formData.note }}
      </p>
    </el-dialog>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
/*global hqWs protocol hqProtocol protocolTrans  http util*/
import { mapGetters } from 'vuex'
let HIDDEN_HQ = false
let ROUTER_PATH = ''
let timer = null
let pushTimer = null
let pushPriceDetailToMPool = []
export default {
  name: 'App',
  data() {
    return {
      showUpdater: false,
      downloadProcess: null,
      dialogVisible: false,
      dataList: [],
      formData: {
        type: null, // 1 跟原来处理一样，拼字段   其他的取接口返回的note
        tradeDay: null,
        commodityInfo: '',
        bsFlag: null,
        quantity: '',
        price: '',
        transferTime: null,
        note: null
      } // 站内信具体的每一条数据
    }
  },
  computed: {
    ...mapGetters([
      'queryTradeAuthArrGetter', // 可展示的商品id列表
      'sessionInfoGetter'
    ]),
    isLogin() {
      if (
        this.sessionInfoGetter &&
        this.sessionInfoGetter['sessionStr'] &&
        this.sessionInfoGetter['userId']
      ) {
        return true
      }
      return false
    }
  },
  watch: {
    isLogin(val, oldVal) {
      if (!val) {
        hqWs.send(hqProtocol.param_SYMBOLS)
        hqWs.send(hqProtocol.param_businessJb)
      }
    }
  },
  async created() {
    // 快捷功能设置
    if (!localStorage.getItem('FAST_SET')) {
      localStorage.setItem('FAST_SET', JSON.stringify(window.g.FAST_SET))
    } else {
      window.g.FAST_SET = JSON.parse(localStorage.getItem('FAST_SET'))
      // 新增快捷功能处理
      if (!window.g.FAST_SET.hasOwnProperty('FAST_Ordersuccess_Playsound')) {
        // 不包含新增项 给默认值
        window.g.FAST_SET.FAST_Ordersuccess_Playsound = true
      }
    }
    localStorage.setItem('TQ_HQ_URL_PATH', window.g.HQ_URL_PATH)
  },
  beforeDestroy() {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
    document.removeEventListener('visibilitychange')
  },
  async mounted() {
    console.log('version 0918', new Date())
    if (window.location.href.indexOf('sessionStr') != -1) { // 判断是否是跳转过来的
      const oldParInfo = decodeURIComponent('userId' + window.location.href.split('userId')[1])
      // const oldParInfo = Object.keys(option)[0]
      const twoInfo = this.urlToObject(oldParInfo)
      const sessionInfo = {}
      sessionInfo.isLogin = true
      sessionInfo.userId = twoInfo.userId
      sessionInfo.sessionStr = twoInfo.sessionStr
      sessionInfo.firmCode = ''
      sessionInfo.tel = twoInfo.tel
      sessionInfo.firmId = twoInfo.firmId
      localStorage.setItem('myPhone', sessionInfo.tel)
      this.$store.commit('setSessionInfo', sessionInfo)
      localStorage.setItem('equipmentFlag_PC', Number(twoInfo.equipmentFlag))
      const toUrl = window.location.href.split('#')[1].split('?')[0]
      await this.initWs() // 初始化行情
      console.log('初始化行情')
      this.$router.push(toUrl)
    } else {
      await this.initWs() // 初始化行情
      this.equipmentSearch()
    }
    this.initData()
    if (window.g.APP_TITLE_ALL) {
      document.title = window.g.APP_TITLE_ALL
    }
    // 仅在Electron模式下
    if (process.env.IS_ELECTRON) {
      this.electronCheckUpdate()
    }
    const _this = this
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        if (!HIDDEN_HQ) {
          // 当页面被隐藏时执行的代码 跳转当前页面至waiting,并暂停心跳/hqws
          HIDDEN_HQ = true
          ROUTER_PATH = _this.$route.fullPath
          // console.log('页面被隐藏了', HIDDEN_HQ)
          // 取消全部订阅
          hqWs.send(hqProtocol.param_unssAll)
          if (ROUTER_PATH !== '/waiting') {
            _this.$router.replace('/waiting')
          }
        }
      } else {
        if (HIDDEN_HQ) {
          HIDDEN_HQ = false
          // 当页面重新变为可见时执行的代码
          // console.log('页面重新变为可见了', HIDDEN_HQ)
          hqWs.send(hqProtocol.param_SYMBOLS)
          hqWs.send(hqProtocol.param_businessJb)
          if (ROUTER_PATH !== '/waiting') {
            _this.$router.replace(ROUTER_PATH)
          }
        }
      }
    })
  },
  methods: {
    async initWs() {
      await this.queryCommodityStrategy() // 不登录也需要请求2022/2/11
      console.log('已缓存商品策略')
      hqWs.register(this.DispathSocketEvent)
      hqWs.send(hqProtocol.param_SYMBOLS)
      hqWs.send(hqProtocol.param_businessJb)
      // 保持ws不掉线
      if (!timer) {
        timer = setInterval(() => {
          const sendData = {
            fid: 'ping-req'
          }
          hqWs.send(sendData)
        }, 10000)
      }
    },
    urlToObject(urlString) {
      var urlObject = {}
      var urlArray = urlString.split('&')
      for (let i = 0, len = urlArray.length; i < len; i++) {
        const urlItem = urlArray[i]
        const item = urlItem.split('=')
        urlObject[item[0]] = item[1]
      }
      return urlObject
    },
    handleClose() {
      // 删除数组的第一个元素
      this.dataList.shift()
      this.dialogVisible = false
      // 进行循环，如果还有数据，继续展示
      const that = this
      setTimeout(function() {
        if (that.dataList.length != 0) {
          that.showDialog()
        }
      }, 500)
    },
    equipmentSearch() {
      var u = navigator.userAgent
      if (u.indexOf('Electron') != -1) {
        // pc 客户端
        localStorage.setItem('equipmentFlag_PC', 1)
      } else {
        // pc web端
        localStorage.setItem('equipmentFlag_PC', 4)
      }
    },

    // 默认风险预警值
    initData() {
      const obj = localStorage.getItem(`setting${this.sessionInfoGetter.tel}`)
      if (!obj) {
        const data = {
          name: '风险预警',
          name1: '风险预警',
          time: [
            util.nowMinFormate(new Date()),
            util.nowMinFormate(new Date())
          ],
          type: [],
          region: '=',
          threshold: '', // 阈值
          frequency: '10', // 频率
          degree: '1',
          delivery: false
        }
        localStorage.setItem(
          `setting${this.sessionInfoGetter.tel}`,
          JSON.stringify(data)
        )
      }
    },
    // 判断当前用户是否修改过资金密码
    getMoneyPwdFlgByFirmId() {
      const that = this
      http.postFront(protocol.param_getMoneyPwdFlgByFirmId).then((response) => {
        const { code, value } = response.data
        if (code === 0 || code === '0') {
          that.$store.commit('setChangeMarginPsd', value)
          if (value === true) {
            that.$alert('登录后请先修改资金密码，否则无法进行交易', '提示', {
              confirmButtonText: '确定',
              callback: (action) => {}
            })
          }
        }
      })
    },
    // 商品策略查询
    async queryCommodityStrategy() {
      const _this = this
      return http
        .postFront(protocol.param_queryCommodityStrategy)
        .then((response) => {
          const { code, message, value } = response.data
          if (code == 0) {
            this.$store.commit('setQueryTradeAuthArr', value)
            this.$store.commit('setCommodityStrategy', value)
            hqWs.send(hqProtocol.param_SYMBOLS)
            hqWs.send(hqProtocol.param_businessJb)
            return true
          } else {
            this.$message(message)
            setTimeout(() => {
              _this.queryCommodityStrategy()
            }, 1000)
            return false
          }
        })
        .catch((e) => {
          setTimeout(() => {
            _this.queryCommodityStrategy()
          }, 1000)
          return false
        })
    },
    // socket接收消息分发函数
    DispathSocketEvent(eventData) {
      if (HIDDEN_HQ) {
        return
      }
      switch (eventData.fid) {
        case 'marketdetail-resp':
          var userAccessArrData = []
          {
            const QueryTradeAuthArr = this.queryTradeAuthArrGetter
            if (sessionStorage.getItem('sessionStr') && sessionStorage.getItem('userId')) {
              const data = eventData.marketDetails
              if (QueryTradeAuthArr.length > 0) {
                for (let i = 0; i < data.length; i++) {
                  const MarketDetail = data[i]
                  for (let j = 0; j < QueryTradeAuthArr.length; j++) {
                    const userAccessId = QueryTradeAuthArr[j]['commodityId']
                    if (String(MarketDetail.symbolId) === String(userAccessId)) {
                      userAccessArrData.push(MarketDetail)
                    }
                  }
                }
              }
              this.$store.commit('updateMarketDetails', userAccessArrData)
              const contractIds = []
              for (const i in userAccessArrData) {
                if (Object.prototype.hasOwnProperty.call(userAccessArrData, i)) {
                  const element = userAccessArrData[i]
                  contractIds.push(element.symbolId)
                }
              }
              hqProtocol.param_subscribe.contractIds = contractIds
              hqWs.send(hqProtocol.param_subscribe)
            } else {
              const data = eventData.marketDetails
              this.$store.commit('updateMarketDetails', data)
              const contractIds = []
              for (const i in data) {
                if (Object.prototype.hasOwnProperty.call(data, i)) {
                  const element = data[i]
                  contractIds.push(element.symbolId)
                }
              }
              hqProtocol.param_subscribe.contractIds = contractIds
              hqWs.send(hqProtocol.param_subscribe)
            }
          }
          break
        case 'top-resp': // ! 返回和使用优化
          {
            const buyLst = eventData.buyLst
            this.$store.commit('buyLst', buyLst)
            const sellLst = eventData.sellLst
            this.$store.commit('sellLst', sellLst)
            this.$store.commit('buyMaxAmount', eventData.maxBuyAmount)
            this.$store.commit('sellMaxAmount', eventData.maxSellAmount)
          }
          break
        case 'TopOneResponse':
          {
            const buyOrderLst = eventData.buyLst
            this.$store.commit('buyOrderLst', buyOrderLst)
            const sellOrderLst = eventData.sellLst
            this.$store.commit('sellOrderLst', sellOrderLst)
          }
          break
        case 'pricedetail-resp': // 分笔全量信息
          {
            const pricedetailData = eventData
            this.$store.commit('pricedetail', pricedetailData)
          }
          break
        case 'PushPriceDetailResponse': // 分笔订阅推送信息
          {
            const PushPriceDetailResponseData = eventData.respList
            this.$store.commit(
              'PushPriceDetailResponse',
              JSON.parse(JSON.stringify(PushPriceDetailResponseData))
            )
            // 价格信息同步到盘口
            this.updateMarketDetails(JSON.parse(JSON.stringify(PushPriceDetailResponseData)))
          }
          break
        case 'PushHoldResponse': // 换手率 仓差和订货量接口
          {
            const PushHoldResponseData = eventData.pushHoldRes
            PushHoldResponseData.contractId = eventData.contractId
            this.$store.commit(
              'PushHoldResponse',
              PushHoldResponseData
            )
          }
          break
        case 'pricedetail-resp-big': // TODO 新增行情信息返回 大单筛选
          {
            const pricedetailData = eventData
            this.$store.commit('pricedetail_big', pricedetailData)
          }
          break
        case 'PushPriceResponse': // TODO 新增推送信息获取
          {
            const PushPriceDetailResponseData = eventData.singlePriceRes
            this.$store.commit(
              'PushPriceDetailResponse_big',
              PushPriceDetailResponseData
            )
          }
          break
        case 'BusinessResponse': // TODO 新增商品行情简介获取
          {
            const BusinessDetail = eventData.businessDetails
            this.$store.commit(
              'setBusinessDetail',
              BusinessDetail
            )
          }
          break
        case 'CurrencyTimeLineResponse': // 分时返回全量信息处理
          {
            const m_data = eventData
            this.$store.commit(
              'setMData',
              m_data
            )
          }
          break
        case 'AddTimeLineResponse': // 分时返回推送信息
          {
            const m_data = eventData
            this.$store.commit(
              'changeMData',
              m_data
            )
          }
          break
        default:
          break
      }
    },
    // 处理分笔信息推送
    updateMarketDetails(data) {
      const pushData = data[data.length - 1]
      let has = false
      for (let i = 0; i < pushPriceDetailToMPool.length; i++) {
        const item = pushPriceDetailToMPool[i]
        if (item.contractId === pushData.contractId) {
          pushPriceDetailToMPool[i] = pushData
          has = true
        }
      }
      if (!has) {
        pushPriceDetailToMPool.push(pushData)
      }
      if (!pushTimer) {
        const _this = this
        pushTimer = setTimeout(() => {
          // console.log('pushPriceDetailToMPool', pushPriceDetailToMPool)
          _this.$store.commit('PushPriceDetailSetMarketDetails', pushPriceDetailToMPool)
          pushPriceDetailToMPool = []
          clearTimeout(pushTimer)
          pushTimer = null
        }, 2000)
      }
    },
    electronCheckUpdate() {
      const { ipcRenderer } = require('electron')
      // 发现新版本
      ipcRenderer.once('autoUpdater-latestVersion', (event, info) => {
        // console.log(event)
        setTimeout(() => {
          // this.$notify({
          //   title: '版本检查',
          //   message: '当前已是最新版本',
          //   type: 'success',
          //   position: 'bottom-right'
          // })
          console.log('当前已是最新版本')
        }, 500)
      })
      ipcRenderer.once('autoUpdater-canUpdate', (event, info) => {
        // console.log(event)
        setTimeout(() => {
          // this.$confirm(`发现有新版本【v${info.version}】，是否更新?`, '提示', {
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          //   confirmButtonClass: 'color-white',
          //   type: 'warning',
          //   closeOnClickModal: false
          // }).then(() => {
          //   ipcRenderer.send('autoUpdater-toDownload')
          // })
          this.$alert(
            `发现有新版本【v${info.version}】，请更新至最新版本`,
            '提示',
            {
              confirmButtonText: '立即更新',
              showClose: false,
              confirmButtonClass: 'color-white',
              callback: action => {
                ipcRenderer.send('autoUpdater-toDownload')
              }
            }
          )
        }, 500)
      })
      // 下载进度
      ipcRenderer.on('autoUpdater-progress', (event, process) => {
        // console.log(event)
        if (process.transferred >= 1024 * 1024) {
          process.transferred =
            (process.transferred / 1024 / 1024).toFixed(2) + 'M'
        } else {
          process.transferred = (process.transferred / 1024).toFixed(2) + 'K'
        }
        if (process.total >= 1024 * 1024) {
          process.total = (process.total / 1024 / 1024).toFixed(2) + 'M'
        } else {
          process.total = (process.total / 1024).toFixed(2) + 'K'
        }
        if (process.bytesPerSecond >= 1024 * 1024) {
          process.speed =
            (process.bytesPerSecond / 1024 / 1024).toFixed(2) + 'M/s'
        } else if (process.bytesPerSecond >= 1024) {
          process.speed = (process.bytesPerSecond / 1024).toFixed(2) + 'K/s'
        } else {
          process.speed = process.bytesPerSecond + 'B/s'
        }
        process.percent = Number(process.percent.toFixed(2))
        this.downloadProcess = process
        this.showUpdater = true
      })
      // 下载更新失败
      ipcRenderer.once('autoUpdater-error', event => {
        setTimeout(() => {
          this.$notify({
            title: '版本更新',
            message: '连接服务器失败，正在尝试重连……',
            type: 'error',
            position: 'bottom-right'
          })
        }, 500)
        setTimeout(() => {
          this.showUpdater = false
        }, 1500)
        const checkNetwork = setInterval(() => {
          if (navigator.onLine === true) {
            ipcRenderer.send('check-update')
            clearInterval(checkNetwork)
          }
        }, 5000)
      })
      // 下载完成
      ipcRenderer.once('autoUpdater-downloaded', () => {
        // this.$confirm(`更新完成，是否关闭应用程序安装新版本?`, '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   confirmButtonClass: 'color-white',
        //   type: 'warning',
        //   closeOnClickModal: false
        // }).then(() => {
        //   ipcRenderer.send('exit-app')
        // })
        this.$alert(`下载完成，即将关闭应用程序安装新版本。`, '提示', {
          confirmButtonText: '立即安装',
          showClose: false,
          confirmButtonClass: 'color-white',
          callback: action => {
            ipcRenderer.send('exit-app')
          }
        })
      })
      ipcRenderer.send('check-update')
    }
  }
}
</script>
<style lang="scss">
@import './assets/images/main.min.css';
@import './assets/images/walletcenter.min.css';
$commonColor: rgba(78, 89, 133, 1);
$componentBgColor: #121212;
$inputAppendWidth: 45%;
#app {
  // min-width: 1400px;
  min-width: 1458px;
  // height: 1015px;
  // overflow: scroll;
  overflow-y: hidden;
}
.tipHeight {
  line-height: 30px;
  font-size: 16px;
  text-indent: 2em;
  max-height: 50vh;
  overflow-y: scroll;
}
* {
  margin: 0px;
  padding: 0px;
  font-family: robotoregular, PingFang SC, Hiragino Sans GB, Heiti SC,
    Microsoft YaHei, WenQuanYi Micro Hei, Helvetica, Arial, monospace, serif;
}
#exchanges .el-dialog {
  background-color: #273562;
  width: 480px;
  height: 462px;

  .el-dialog__header {
    background-color: #2b3f71;
    padding: 20px;
  }
}
#exchanges #gsHt .el-dialog {
  width: 50%;
}
#nonTransCCNewNotice .el-dialog {
  background-color: #282b32;
  width: 480px;
  // height: 462px;

  .el-dialog__header {
    background-color: #323540;
    padding: 20px;
  }
}
// .el-button--text{
//   color: black !important;
// }
.button.iconed,
.header-chart-panel .button.iconed {
  padding: 6px 4px 6px !important;
}
a {
  text-decoration: none;
}
li {
  list-style: none;
}
/*清除浮动*/
.cleartext:after {
  content: '';
  height: 0;
  line-height: 0;
  visibility: hidden;
  clear: both;
  display: block;
}
.clearfix {
  zoom: 1;
}
body {
  font-size: 12px;
  font-family: robotoregular, PingFang SC, Hiragino Sans GB, Heiti SC,
    Microsoft YaHei, WenQuanYi Micro Hei, Helvetica, Arial, monospace, serif;

  /* font-family: '微软雅黑'; */
  // background-color: #242c4c;
  // background-color: #ffffff;
  background-color: #000;
}

/*版心*/
.w {
  width: 1240px;
  margin: 0 auto;
} // 布局
#transCC .aw {
  min-width: 1250px !important;
  margin: 0px !important;
}
.alignRight {
  display: inline-block;
  text-align: right;
}
.alignCenter {
  display: inline-block;
  text-align: center;
}
.rowMargin {
  margin-top: 10px;
}
.componentBackgroundColor {
  background-color: $componentBgColor;
}
.whiteEleLabel .el-form-item__label {
  color: white;
}
.eleInputText .el-input__inner {
  background-color: $componentBgColor;
  border-color: #ffffff;
  color: #ffffff;
}
.commonBorderColor {
  border-color: $commonColor;
}
.msgYzmInput .el-input-group__append {
  background-color: $commonColor;
  border: 0;
  padding: 0;
  width: $inputAppendWidth;
  text-align: center;
}
.msgYzmInput .el-input-group__append .el-button {
  background-color: $commonColor;
  border: 0;
}
.imgYzmInput .el-input-group__append {
  width: $inputAppendWidth;
}
#login .msgYszmInput .el-input__inner{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right:0;
}
//card选项卡的样式
$cardBgColor: rgba(32, 35, 44, 1);
$cardHeaderBgColor: #192a53;
.box-card .el-card__header {
  background-color: $cardHeaderBgColor;
  font-size: 16px;
  font-family: 'MicrosoftYaHei', '微软雅黑';
  font-weight: 400;
  border: 0;
}
$fontCardContentSize: 14px;
$cardBgColor: rgba(32, 35, 44, 1);
$cardHeaderBgColor: rgba(38, 42, 66, 1);
.cardContent {
  font-size: $fontCardContentSize;
}
.box-card,
.leftNavContainer {
  width: 100%;
  background-color: $cardBgColor;
  border: 0;
}
.box-card .el-card__header {
  background-color: $cardHeaderBgColor;
} //table的样式
$tableBgColor: #ffffff;
// $tableHoverColor: #ffffff;
.el-table {
  background-color: $tableBgColor;
  font-size: 14px;
  font-weight: 300;
  table tr,
  th {
    background-color: $tableBgColor;
  }

  // IE
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #414552;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #242c4c;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #232633;
  /*滚动条阴影*/
  scrollbar-shadow-color: #666;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #232633;
}
.el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
.el-table__body tr.current-row > td,
.el-table__body tr.hover-row.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped > td,
.el-table__body tr.hover-row > td {
  background-color: #2b2f44;
}
.el-table td,
.el-table th {
  padding: 5px 0;
}
.el-table__row {
  height: 70px;
}
.el-table__row:hover tr > td {
  background-color: #2b2f44;
}
.el-table td,
.el-table th.is-leaf {
  border: 0;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: transparent;
}
.el-table::before{
  height:0!important;
}
.el-table__fixed-right::before,
.el-table__fixed::before {
  background-color: transparent;
} // 表头和body加线
.bodyLine .el-table__header-wrapper {
  border-bottom: solid 1px #979797;
}
#transcc_new_newfooter .el-table td,#transcc_new_newfooter .el-table th.is-leaf{
   border-bottom: 1px solid #2b2b2b;
}
#transcc_new_newfooter .el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td{
  background-color: #ffffff;
    color: #f0f1f4;
}
#transcc_new_newfooter .el-table__footer-wrapper td{
border-top: 1px solid #2b2b2b;
}
#transcc_new_newfooter .el-table--border td,#transcc_new_newfooter .el-table--border th,#transcc_new_newfooter .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
  border-right:1px solid #2b2b2b;
}

//tabs

.el-tabs__item {
  color: #ffffff;
}
.tltCenter .el-tabs__nav {
  display: absolute;
  left: 50%;
  transform: translateX(-50%) !important;
} //dialog
.el-dialog {
  background-color: rgba(38, 53, 98, 1);
}
// .el-dialog input,
// .el-dialog .el-input__inner {
//   background: rgba(43, 64, 113, 1);
//   border: 1px solid #1b1d24 !important;
//   color: #bfc3ce;
// }
.el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
.el-date-picker {
  color: black;
}
.el-dialog__title,
.el-dialog__body {
  color: #333333 !important;
} //下拉框

//时间插件
.el-date-table span {
  color: #606266;
} // 分页插件
.el-form-item__label {
  color: #bfc3ce;
}

// 英文通用样式
.enHeader + .router-view .el-table th div.cell {
  word-break: keep-all;
}
// 白色背景的分页的页数样式
.paginationPage {
  &.el-pagination {
    span {
      font-size: 12px !important;
    }
    .el-select .el-input .el-input__inner{
      background-color: transparent;
      border-color: #DCDFE6;
    }
    .el-pager {
      li {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
      }
      li:hover {
        color: #333333;
      }
      li.active {
        font-weight: 600;
        color: #333333;
      }
    }
    button:disabled, button, button:disabled:hover {
      color: #C0C4CC;
    }
    button:hover {
      color: #303133;
    }
    .el-input {
      .el-input__inner:focus, .el-input__inner:hover {
        border-color: #DCDFE6; 
      }
    }
    input[type="number"]{
      text-indent: 0;
    }
  }
}
// 分页下拉框修改
._popStyle{
  min-width: 100px !important;
  .el-select-dropdown__item.selected{
    color: #333333;
  }
  .el-select-dropdown__list{
    width: 100px !important;
  }
  .el-select-dropdown__item{
    color: #333333;
    width: 100%;
  }
  .el-scrollbar__wrap{
    margin-right: -8px !important;
    margin-bottom: -8px !important;
  }
}
// 分页下拉框修改
.dark_popStyle{
  min-width: 100px !important;
  .el-select-dropdown__item.selected{
    text-align: left !important;
  }
  .el-select-dropdown__list{
    width: 100px !important;
  }
  .el-select-dropdown__item{
    width: 100%;
  }
  .el-scrollbar__wrap{
    margin-right: -8px !important;
    margin-bottom: -8px !important;
  }
}
// 持仓部分下拉框修改
._ccStyle{
  &.el-select-dropdown{
    background-color: #010101 ;
    color: #979797;
  }
  .el-select-dropdown__item.hover, 
  .el-select-dropdown__item:hover{
    color:#dfdfdf;
    background-color: #2C2C2C;
  }
  .el-select-dropdown__item.selected{
    text-align: left !important;
  }
  // .el-select-dropdown__list{
  //   width: 221px !important;
  // }
  .el-select-dropdown__item{
    width: 100%;
  }
  .el-scrollbar__wrap{
    margin-right: -8px !important;
    margin-bottom: -8px !important;
  }
}
// 委托和成交下拉框修改
._wtCjStyle{
  &.el-select-dropdown{
    background-color: #010101 ;
    color: #979797;
  }
  .el-select-dropdown__item.hover, 
  .el-select-dropdown__item:hover{
    color:#dfdfdf;
    background-color: #2C2C2C;
  }
  .el-select-dropdown__item.selected{
    text-align: left !important;
  }
  .el-select-dropdown__list{
    width: 160px !important;
  }
  .el-select-dropdown__item{
    width: 100%;
  }
  .el-scrollbar__wrap{
    margin-right: -8px !important;
    margin-bottom: -8px !important;
  }
}
._whiteSelect {
  padding: 5px 0;
  margin: 5px 0;
  .el-select-dropdown__item {
    text-align: left;
    padding-left: 15px;
    span {
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }
  }
  .el-select-dropdown__item.selected {
    background: #F1F1F1;
    float: none;
    span {
      color: #333333;
    }
  }
  .el-select-dropdown__item.hover{
    background: #F1F1F1;
  }
  .el-scrollbar__wrap{
    margin-right: -8px !important;
    margin-bottom: -8px !important;
  }
}
// 表单下拉框样式
._formSelect {
  .el-select-dropdown__item {
    span {
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }
  }
  .el-select-dropdown__item.selected {
    background: #F1F1F1;
    span {
      color: #333333;
    }
  }
  .el-select-dropdown__item.hover{
    background: #F1F1F1;
  }
  .el-scrollbar__wrap{
    margin-right: -8px !important;
    margin-bottom: -8px !important;
  }
}
.increaseColor,
.increaseColor > * {
  color: #D94066 !important;
}
.dropColor,
.dropColor > * {
  color: #41b37d !important;
}
.el-main {
  min-height: 600px;
}
.el-message-box__wrapper {

  .blackMessage.el-message-box {
    width:540px;
    // height: 190px;
    border-radius: 8px;
    border: 1px solid #545454;
    background: #1A1A1A !important;
    padding-bottom: 40px;
    .el-message-box__header {
      padding: 0;
    }
    .el-message-box__content {
      text-align: center;
      padding: 0;
      margin: 64px 0 30px 0;
      padding: 0 20px;
    }
    .el-message-box__message {
      p {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
      }
    }
    .el-message-box__btns {
      text-align: center;
      display: flex;
      flex-direction: row-reverse;
      justify-content: center;
      .el-button{
        padding: 0px 23px;
        width: 74px;
        height: 24px;
        line-height: 24px;
        background: #272727;
        border-radius: 12px;
        border: 1px solid #404040;
        span{
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 14px;
          color: #DFDFDF;
        }
      }
      .el-button--primary {
        margin-right:10px;
        border: 0;
      }
    }
  }
}
// 黑色背景弹窗
.newPopup{
  .el-dialog{
    width:540px;
    height: 190px;
    border-radius: 8px;
    border: 1px solid #545454;
    background: #1A1A1A !important;
  }
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    text-align: center;
    padding: 0;
    margin: 64px 0 30px 0;
    span{
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    }
  }
  .el-dialog__headerbtn{
    top:40px;
    .el-dialog__headerbtn .el-dialog__close{
      font-size:22px;
      color: rgba(255, 255, 255, 0.2);
    }
  }
  .el-dialog__footer{
    text-align:center;
    padding:0px 40px 40px;
    .el-button{
      padding: 0px 23px;
      width: 74px;
      height: 24px;
      line-height: 24px;
      background: #272727;
      border-radius: 12px;
      border: none;
      span{
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #DFDFDF;
      }
    }
    .surexBtn{
      padding: 0px 23px;
      width: 74px;
      height: 24px;
      border-radius: 12px;
      margin-left:10px;
      span{
        color:#DFDFDF;
      }
    }
    .canclexBtn{
      border: 1px solid #404040;
    }
  }
}
.el-date-table td.end-date span, .el-date-table td.start-date span{
  color:#fff;
}
.el-date-table .in-range span{
  color:#409EFF;
}
.dark_date_picker.el-picker-panel{
  border:1px solid rgba(255,255,255,0.5)!important;
  background:#131625!important;
}
.dark_date_picker.el-picker-panel__body {
  background-color: #131625;
  border: 1px solid #131625;
}
.dark_date_picker.el-picker-panel__footer {
  background-color: #131625;
  border: 1px solid #131625;
}

.dark_date_picker.el-picker-panel__body .el-date-range-picker__content.is-left{
      border-right: 1px solid rgba(255,255,255,0.5);
}
.el-popper[x-placement^=top] .popper__arrow::after{
  border-top-color: #131625!important;
}
.dark_date_picker.el-picker-panel__content .el-date-table th{
  border-bottom: solid 1px rgba(255,255,255,0.5);
}
.dark_date_picker.el-picker-panel .el-button {
  background-color: #409eff;
}
.dark_date_picker.el-picker-panel .el-button--text {
  background-color: #131625;
}
.dark_date_picker.el-picker-panel .el-input__inner {
  // background: black;
  border: 1px solid #131625;
}
.dark_date_picker.el-picker-panel .el-button.is-plain:hover {
  background: #3a8ee6;
}
.dark_date_picker.el-picker-panel .el-date-range-picker__header .el-picker-panel__icon-btn {
  color: white !important;
}
.el-table th > .cell {
  white-space: nowrap;
  overflow: hidden;
  font-weight: normal;
  color: #61688a;
}
.el-slider__button {
  border: 2px solid #d74e5a;
  width: 8px;
  height: 8px;
}
.buyStep .el-slider__bar {
  background-color: #ffffff;
}
.tradStep .el-slider__button {
  border: 2px solid #41b37d;
  // border: 2px solid #d74e5a;
}
.buyStep .el-slider__button {
  // border: 2px solid #41b37d;
  border: 2px solid #d74e5a;
}
.tradStep .el-slider__bar {
  background-color: #ffffff;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #F1F1F1 !important;
}
.el-table__body tr.honer-row > td {
  background-color: #F1F1F1 !important;
}
.el-carousel__arrow {
  font-size: 40px !important;
}
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: transparent;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: transparent!important;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #1b1e28!important;
}
/*滑块效果*/
// ::-webkit-scrollbar-thumb:hover
// {
// border-radius: 5px;
// -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
// background: rgba(0,0,0,1);
// }
/*IE滚动条颜色*/
html {
  scrollbar-face-color: #0c0c0c; /*滚动条颜色*/
  scrollbar-highlight-color: transparent;
  scrollbar-3dlight-color: transparent;
  scrollbar-darkshadow-color: transparent;
  scrollbar-shadow-color: transparent; /*滑块边色*/
  scrollbar-arrow-color: rgba(0, 0, 0, 0.4); /*箭头颜色*/
  scrollbar-track-color: transparent; /*背景颜色*/
}
/deep/ .el-input-group__append {
  background: transparent;
  border: 1px solid rgba(220, 223, 234, 0.3);
  border-left: none;
}
#exchanges .el-input-group__append .el-button {
  background: transparent !important;
}
// 白色背景下 查询样式
.mainPage {
  background-color:#ffffff;
  min-height: calc(100vh - 60px) !important;
  // 版心
  .typeArea {
    width: 1200px;
    margin: 0 auto;
    // 一级分类
    .firstWrap {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e9e9e9;
      div {
        margin-right: 10px;
        height: 49px;
        line-height: 49px;
        padding: 0 5px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 16px;
        color: #909090;
        cursor: pointer;
        border-bottom: 2px solid transparent;
      }
      .activeFirst{
        border-color: #707070;
        color: #000000;
      }
    }
    // 二级分类
    .secondWrap {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e9e9e9;
      div {
        margin-right: 15px;
        height: 48px;
        line-height: 48px;
        padding: 0 3px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #909090;
        cursor: pointer;
        border-bottom: 2px solid transparent;
      }
      .activeSecond{
        border-color: #707070;
        color: #000000;
      }
    }
    // 查询部分的样式
    .chooseWrap {
      padding: 14px 0;
      display: flex;
      align-items: flex-end;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      // 查询组件个体
      .itemSearch{
        margin-right: 20px;
        // 时间选择器 选中后的 边框颜色
        .el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
          border-color: #DCDFE6;
        }
        // 表单框 鼠标放上去和选中的颜色
        .el-input__inner:hover,  .el-input__inner:focus{
            border-color: #DCDFE6;
        }
        // 查询label
        .searchTitle{
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          margin-bottom: 7px;
        }
        // 查询主体
        .searchContent {
          height: 40px;
          display: flex;
          align-items: center;
          .el-input {
            width: 200px;
            .el-input__inner {
              font-family: Source Han Sans SC;
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              border-color: #E5E5E5;
              &:focus {
                border-color: #E5E5E5;
              }
            }
          }
          // 单选框样式
          .el-radio-group {
            .el-radio__input {
              height: 12px;
              &.is-checked {
                .el-radio__inner {
                  border-color: #DCDFE6;
                  background: #000000;
                }
                & + .el-radio__label {
                  color: #000000;
                }
              }
              .el-radio__inner {
                width: 12px;
                height: 12px;
                border-radius: 0;
                &::after{
                  width: 0;
                  height: 0;
                  border-radius: 0;
                }
              }
            }
          }
        }
      }
      // 查询重置按钮
      .actionSearch {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 40px;
        // 按钮共用
        .el-button {
          // width: 80px;
          // height: 36px;
          padding: 10px 25px;
          border-radius: 20px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 14px;
        }
        // 查询
        .searchBtn {
          background: #000000;
          border: 1px solid #000000;
          color: #FFFFFF;
        }
        // 搜索
        .restBtn {
          background: #FFFFFF;
          border: 1px solid #E2E2E2;
          color: #000000;
        }
      }
    }
    #tablePage {
      .el-table {
        .operation {
          padding: 4px 14px;
          border-radius: 24px;
          background: #000;
          color: #ffffff;
          font-weight: 600;
          cursor: pointer;
        }
        .operation + .operation {
          margin-left: 10px;
        }
        .descending .sort-caret.descending {
          border-top-color: #000000;
        }
        .ascending .sort-caret.ascending {
          border-bottom-color: #000000;
        }
        .el-table__header-wrapper {
          .el-table__cell {
            padding: 2px 0;
            border-bottom: 1px solid #e9e9e9;
            .cell {
              text-align: center;
              height: 34px;
              line-height: 34px;
              font-family: Source Han Sans SC;
              font-weight: 400;
              font-size: 12px;
              color: #333333;
            }
          }
        }
        .el-table__body-wrapper {
          .el-table__row {
            height: 60px;
            .el-table__cell {
              padding: 0;
              border-bottom: 1px solid #e9e9e9;
              .cell {
                text-align: center;
                font-family: Source Han Sans SC;
                font-weight: 400;
                font-size: 12px;
                color: #333333;
              }
            }
          }
        }
        .el-table__empty-text {
          width: auto;
          line-height: normal;
          .no-datas {
            text-align: center;
            .no-data-img {
              width: 100px;
              height: 100px;
            }
            .no-data {
              font-family: Source Han Sans SC;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
            }
          }
        }
      }
      .paginateWrap  {
        span {
          font-size: 12px;
        }
        text-align: center;
        // 白色背景的分页的页数样式
        .el-select .el-input .el-input__inner{
          background-color: transparent;
          border-color: #DCDFE6;
        }
        .el-pager {
          li {
            font-family: Source Han Sans SC;
            font-weight: 400;
            font-size: 12px;
            color: #333333;
          }
          li:hover {
            color: #333333;
          }
          li.active {
            font-weight: 600;
            color: #333333;
          }
        }
        .el-input__inner:focus, .el-input__inner:hover {
          border-color: #DCDFE6; 
        }
        button:disabled, button, button:disabled:hover {
          color: #C0C4CC;
        }
        button:hover {
          color: #303133;
        }
      }
    }
  }
  .mainDialog {
    .el-dialog {
      background: #ffffff !important;
      border-radius: 8px;
      font-size: 18px;
      .el-dialog__header {
        padding: 30px 0;
        .el-dialog__title {
          font-size: 24px;
          font-weight: 800;
        }
        .el-dialog__headerbtn {
          top: 30px;
          right: 30px;
        }
        // 关闭按钮 触摸 和 激活状态下的颜色
        .el-dialog__headerbtn .el-dialog__close,
        .el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
            color: #909399;
            font-size: 24px;
        }
      }
      .el-dialog__body {
        padding: 0 30px;
        .itemSearch {
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          .title{
            width: 80px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
          .el-select, .inputsWrap{
            // width: calc(100% - 80px);
            flex: 1;
            .el-input__icon {
              line-height: 30px;
            }
          }
          .el-dialog input,.el-input__inner {
            height: 30px;
            line-height: 30px;
            border: 1px solid #999999 !important;
            background-color: transparent;
            font-family: Source Han Sans SC;
            font-weight: 400;
            font-size: 12px;
            color: #333333;
            // color: #999999;
          }
        }
      }
      .el-dialog__footer {
        .el-button {
          border-radius: 23px;
          padding: 9px 45px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
          border: 1px solid;
        }
        .conBtn {
          border-color: #000000;
          background: #000000;
          margin-right: 18px;
        }
        .canelBtn {
          border-color: #000000;
          color: #000000;
        }
      }
    }
  }
  // 数字输入框 不要首行缩进
  input[type='number'] {
    text-indent: 0;
  }
  // 数字输入框 不要右边加减
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
}
</style>
<style>
/* .el-table th.gutter,.el-table th {
  display: table-cell !important;
}
.el-table colgroup.gutter,.el-table colgroup {
  display: table-cell !important;
} */
@keyframes flash {
  0% {
    background-color: rgb(26, 37, 61);
    opacity: 1;
  }
  50% {
    background-color: rgba(255, 0, 0, 0.2);
  }
  100% {
    background-color: rgb(26, 37, 61);
  }
}
@-webkit-keyframes flash {
  0% {
    background-color: rgb(26, 37, 61);
    opacity: 1;
  }
  50% {
    background-color: rgba(255, 0, 0, 0.2);
  }
  100% {
    background-color: rgb(26, 37, 61);
  }
}
@keyframes flashgreen {
  0% {
    background-color: rgb(26, 37, 61);
    opacity: 1;
  }
  50% {
    background-color: rgba(0, 255, 0, 0.2);
  }
  100% {
    background-color: rgb(26, 37, 61);
  }
}
@-webkit-keyframes flashgreen {
  0% {
    background-color: #383f66;
    opacity: 1;
  }
  50% {
    background-color: rgba(0, 255, 0, 0.2);
  }
  100% {
    background-color: #383f66;
  }
}
.upflash {
  -webkit-animation-name: flashgreen;
  -webkit-animation-duration: 500ms;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
}
.downflash {
  -webkit-animation-name: flash;
  -webkit-animation-duration: 500ms;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
}

</style>